import { html, LitElement } from "lit"
import { customElement, property } from "lit/decorators.js"
import { ICON_BASE } from "../../styles/base"

@customElement("eye-invisible-icon")
export class EyeInvisibleIcon extends LitElement {
  static override styles = [ICON_BASE]

  @property({ type: String })
  color = "currentColor"

  @property({ type: String })
  size = "30px"

  override render() {
    return html`
      <svg
        width=${this.size}
        height=${this.size}
        viewBox="0 0 30 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill=${this.color}
      >
        <title>Invisible (eye)</title>
        <g id="Invisible-(eye)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M1.7070312,0.59 L0.29296875,2.00406245 L28.2929687,30.0040623 L29.707031,28.59 L23.681641,22.5646093 C27.777456,19.7913713 29.799165,15.9136673 29.826172,15.8614843 C29.9396226,15.6951255 30.0000005,15.4983921 30.0000005,15.2970313 C30.0000005,15.0714747 29.9234465,14.8525938 29.783203,14.6759373 C29.679012,14.5082113 23.918297,5.29703125 15,5.29703125 C12.469857,5.29703125 10.199331,6.04722345 8.234375,7.11734375 L1.7070312,0.59 Z M15,8.29703125 C18.866,8.29703125 22,11.4310313 22,15.2970313 C22,16.8689873 21.470043,18.3098793 20.59375,19.4767193 L17.701172,16.5841403 C17.889655,16.1948503 18,15.7598773 18,15.2970313 C18,13.6400313 16.657,12.2970313 15,12.2970313 C14.537154,12.2970313 14.102181,12.4073763 13.712891,12.5958593 L10.820312,9.70328125 C11.987152,8.82698775 13.428044,8.29703125 15,8.29703125 Z M4.9511719,9.37320315 C1.9791583,11.8731563 0.27498083,14.5840623 0.21875,14.6739843 C0.0773890257,14.8509064 0.000265439074,15.0705709 -1.0658141e-13,15.2970313 C-1.0658141e-13,15.4905304 0.0564899972,15.6798222 0.16210938,15.8419533 C0.16340458,15.8439108 0.164706668,15.8458638 0.16601562,15.8478123 C0.18320928,15.8832923 5.0188313,25.2970313 15,25.2970313 C16.85,25.2970313 18.520531,24.9705153 20.019531,24.4435153 L17.431641,21.8536723 C16.672641,22.1356723 15.856,22.2970313 15,22.2970313 C11.134,22.2970313 8,19.1630313 8,15.2970313 C8,14.4410313 8.1613594,13.6243903 8.4433594,12.8653903 L4.9511719,9.37320315 Z"
            id="Shape"
            fill=${this.color}
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eye-invisible-icon": EyeInvisibleIcon
  }
}
